/**
 * Header tools.
 */
H_Tools.header = (() => {
    let doc = document.documentElement;

    /**
     * Sets the stored height of the header to the specified value.
     *
     * @param {*} headerHeight A new height for the header
     */
    function setHeight(headerHeight) {
        // console.log(`Header height: ${headerHeight}`);
        doc.style.setProperty('--header-height', `${headerHeight}px`);
        H_Tools.header.height = headerHeight;
        doc.dispatchEvent(new Event('header-measured'));
    }

    // Return an object to expose inner functions
    return {
        height: 0,
        setHeight: setHeight,
    };
})();
